/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   getSavedCustomMessage.ts
 */

import { localStorageSingleton } from '@zcode/nr-utils'
import type { Dispatch } from 'redux'
import { SAVED_CUSTOM_MESSAGE_LOCALSTORAGE_KEY } from '../../constants'
import { setCustomMessageChecked } from '../actions'

export const getSavedCustomMessage =
  () =>
  (dispatch: Dispatch): string | undefined => {
    const savedCustomMessage = localStorageSingleton.getx(SAVED_CUSTOM_MESSAGE_LOCALSTORAGE_KEY)

    if (savedCustomMessage) {
      dispatch(setCustomMessageChecked(true))
    }

    return savedCustomMessage
  }
